import React, { Component } from 'react';
import './../css/signin.css';
import aidao from './../assets/images/dao_token_letter.svg';
import PopUp from './dashboard/functions/popup.js';
import content from './data/content.js';
import $ from 'jquery';
import axios from 'axios';
import qs from 'qs';

export default class Login extends Component {

  render() {

    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = 'X-CSRFToken';

    var data = content[0]["page"]["login"];

    var login = function() {
        var username = $("#username-login").val();
        var password = $("#password-login").val();
        var recaptcha = $("#g-recaptcha-response").val();

        if (username === "" || password === "") {
          PopUp.prototype.show(data["empty"]);
        } else {
          var request = axios.post('/api/login', qs.stringify({
            "username": username,
            "password": password,
            "token": $("#otp-login").val(),
            "g-recaptcha-response": recaptcha,
          }));
          request.then(function (response) {
            if (response.data.status === "success") {
              window.location.href = "/dashboard";
            } else if (response.data.status === "otp_required") {
              PopUp.prototype.show("Failed:\n you are required to enter opt tokens");
            }
          });
          request.catch(function (error) {
            PopUp.prototype.show("Failed:\n"+ error.response.data.message);
          });
        }
    }

    return (
    <div id="wrapper">
      <div class="container">

        <div class="fixed-card-box">
            <div class="logo m-t-30 m-b-30">
                <img src={aidao} alt="AiDAO logo" class="login_logo"/>
            </div>

                <div class="form-group">
                    <input type="text" placeholder={data.enterUsername} class="form-control" id="username-login" required/>
                </div>
                <div class="form-group">
                    <input id="password-login" type="password" placeholder={data.enterPassword} class="form-control" required />
                </div>
                <p>{data.otpLabel}</p>
                <div class="form-group otp-form-login">
                    <input id="otp-login" type="text" placeholder={data.enterOtp}class="form-control" required />
                </div>
                <div class="center">
                  <div class="g-recaptcha distance" data-sitekey="6LcrwD0UAAAAAOvi683E0yW6qkjkrWUZNWRYEWZk"></div>
                </div>

                <div class="grey_btn m-b-20">
                  <button onClick={login} class="btn btn-block btn-default waves-effect waves-light btn-md p-t-5 p-b-5">{data.loginbutton}</button>
                </div>

                <p class="text-right"><a href="/resetpassword">{data.resetpassword}</a></p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/login.js